import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const Footer = ({ sx }) => {
  return (
    <Box sx={sx}>
      <Box sx={{ mx: 'auto', mt: 7 }}>
        <Typography
          align="center"
          display="block"
          sx={{
            fontFamily:
              'Poppins, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            fontWeight: 300,   // Light
            fontStyle: 'italic'
          }}
        >
          Kladiora© Tüm Hakları Saklıdır.
        </Typography>
      </Box>
    </Box>
  )
}

Footer.propTypes = {
  // MUI `sx` prop'u: object | array | func olabilir
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
}

export default Footer
